import { QueryConfig } from "./Queries";

export const localesQuery = (): QueryConfig => {
  const query = `query getLocales {
            locales {
             id
             code
             displayName
            }
        }`;
  return {
    query: query,
    variables: {},
  };
};
